import { AccentIcon } from '@workday/canvas-kit-react/icon';
import { WcpStyles } from '@workday/wcp-tokens';
import React from 'react';

export const ThemedAccentIcon: React.FC<React.ComponentProps<typeof AccentIcon>> = ({ color, ...props }) => (
  <AccentIcon color={color || WcpStyles.color.fg.default} {...props} />
);
